import { render } from "./stepSection.vue?vue&type=template&id=40b1800f&scoped=true"
import script from "./stepSection.vue?vue&type=script&lang=js"
export * from "./stepSection.vue?vue&type=script&lang=js"

import "./stepSection.vue?vue&type=style&index=0&id=40b1800f&scoped=true&lang=css"

import exportComponent from "/Users/content/Documents/Biggie/triple_palm/photography-landing-page-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b1800f"]])

export default __exports__